import { gql } from '@apollo/client'

export const UPDATE_NOTE = gql `
  mutation UpdateNote(
    $noteId: ID!
    $title: String
    $keyword: String
    $content: String
  ) {
     updateNote(updateNoteInput: { 
       noteId: $noteId
       title: $title,
       keyword: $keyword,
       content: $content
      }) {
      _id
      title
    }
}
`